import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthProvider";
import { routes } from "./utils/routes";
import { configureSEO } from "./utils/seoConfig";
import { Header, Footer } from "./components/parts";
import DevPasswordProtection from "./components/parts/devPasswordProtection";
import {
  Home,
  About,
  Contact,
  FindLocation,
  Login,
  CancoCashLoyalty,
  Register,
  InStore,
  WorkWithUs,
  Business,
  CancoFleetCard,
  ForgotPassword,
  ResetPassword,
  CancoConnect,
  BecomeVendor,
  BecomeDealer,
  Blogs,
  BlogInner,
  BecomeRealtor,
  BecomeRetailAgent,
  // BecomeFleetCardMember,
  TermsAndCondition,
  PrivacyPolicy,
  EmailConfirmation,
  UserProfile,
  ThankYou,
  Survey,
  RequestAccountDeactivation,
  SuccessAccountDeletionRequest,
  RoadTripRules,
  CancoContest,
  SchoolSpirit,
  MissingPoints,
  WholesaleBusiness,
  // Careers,
  CreditApplication,
  XpressCardlockApplication,
  MerchantApplication,
  CancoAllLocations,
} from "./screens";
import "./App.scss";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    // Configure SEO based on environment
    configureSEO();

    // Google tag (gtag.js) - only load in production
    if (process.env.REACT_APP_ENV === "prod") {
      const gtagScript = document.createElement("script");
      gtagScript.async = true;
      gtagScript.src = "https://www.googletagmanager.com/gtag/js?id=AW-17907780792";
      document.head.appendChild(gtagScript);

      const gtagConfig = document.createElement("script");
      gtagConfig.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-17907780792');
      `;
      document.head.appendChild(gtagConfig);
    }

    if (process.env.REACT_APP_GTM_ID) {
      // Create and append the script element for gtag.js
      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_GTM_ID}`;
      document.head.appendChild(script);

      // Insert the GTM script to configure gtag
      const gtagScript = document.createElement("script");
      gtagScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${process.env.REACT_APP_GTM_ID}');
      `;
      document.head.appendChild(gtagScript);
    }
  }, []);
  return (
    <DevPasswordProtection>
      <AuthProvider>
        <main>
          <Header />
          <Routes>
            <Route path={routes.HOME} element={<Home />} />
            <Route path={routes.ABOUT} element={<About />} />
            <Route path={routes.CONTACT} element={<Contact />} />
            <Route path={routes.FIND_LOCATION} element={<FindLocation />} />
            <Route
              path={routes.CANCO_ALL_LOCATIONS}
              element={<CancoAllLocations />}
            />
            <Route path={routes.LOGIN} element={<Login />} />
            <Route
              path={routes.CANCO_CASH_LOYALTY}
              element={<CancoCashLoyalty />}
            />
            <Route path={routes.REGISTER} element={<Register />} />
            <Route path={routes.IN_STORE} element={<InStore />} />
            <Route path={routes.WORK_WITH_US} element={<WorkWithUs />} />
            <Route path={routes.BUSINESS} element={<Business />} />
            <Route path={routes.CANCO_FLEET_CARD} element={<CancoFleetCard />} />
            <Route path={routes.CANCO_CONNECT} element={<CancoConnect />} />
            <Route path={routes.BECOME_VENDOR} element={<BecomeVendor />} />
            <Route path={routes.BECOME_DEALER} element={<BecomeDealer />} />
            <Route path={routes.BECOME_DEALER} element={<BecomeDealer />} />
            <Route path={routes.BECOME_REALTOR} element={<BecomeRealtor />} />
            <Route path={routes.BECOME_RETAIL_AGENT} element={<BecomeRetailAgent />} />
            <Route path={routes.SURVEY} element={<Survey />} />
            <Route
              path={routes.BECOME_FLEET_CARD_MEMBER}
              element={<Navigate to={routes.HOME} replace />}
            />
            <Route path={routes.BLOGS} element={<Blogs />} />
            <Route path={routes.EDIT_USER_PROFILE} element={<UserProfile />} />
            <Route path={`/${routes.THANK_YOU}`} element={<ThankYou />} />
            <Route path={routes.SINGLE_BLOG} element={<BlogInner />} />
            <Route path={routes.CREDIT_APPLICATION} element={<CreditApplication />} />
            <Route
              path={routes.WHOLESALE_BUSINESS}
              element={<WholesaleBusiness />}
            />
            <Route
              path={routes.TERMS_CONDITION}
              element={<TermsAndCondition />}
            />
            <Route
              path={routes.PRIVACY_POLICY}
              element={<PrivacyPolicy />}
            />
            <Route
              path={routes.EMAIL_CONFIRMATION}
              element={<EmailConfirmation />}
            />
            <Route path={routes.FORGOT_PASSWORD} element={<ForgotPassword />} />
            <Route path={routes.RESET_PASSWORD} element={<ResetPassword />} />
            <Route
              path={routes.REQUEST_ACOOUNT_DEACTIVATION}
              element={<RequestAccountDeactivation />}
            />
            <Route
              path={routes.SUCCESS_ACOOUNT_DEACTIVATION}
              element={<SuccessAccountDeletionRequest />}
            />
            <Route path={routes.ROAD_TRIP_RULES} element={<RoadTripRules />} />
            <Route path={routes.CANCO_CONTEST} element={<CancoContest />} />
            <Route path={routes.SCHOOL_SPIRIT} element={<SchoolSpirit />} />
            <Route path={routes.MISSING_POINT} element={<MissingPoints />} />
            <Route
              path={routes.MERCHANT_APPLICATION}
              element={<MerchantApplication />}
            />
            {/* <Route path={routes.CAREERS} element={<Careers />} /> */}
            <Route path={"/signup"} element={<Navigate to={routes.REGISTER} />} />
            <Route
              path={"/TermsAndPrivacy"}
              element={<Navigate to={routes.TERMS_CONDITION} />}
            />
            <Route
              path={routes.WHOLESALE_BUSINESS}
              element={<WholesaleBusiness />}
            />
            <Route
              path={routes.XPRESS_CARDLOCK_APPLICATION}
              element={<XpressCardlockApplication />}
            />
          </Routes>
          <Footer />
          <a href={routes.SURVEY} className="floatingBtn">
            feedback
          </a>
        </main>
      </AuthProvider>
    </DevPasswordProtection>
  );
}

export default App;
